var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.549805 0C0.810241 0.000210396 1.02636 0.181624 1.08301 0.424805L4.75 1.66309H4.75098C5.1789 1.80451 5.54356 1.98537 5.8125 2.21191C6.08248 2.43946 6.29802 2.75207 6.31055 3.13965C6.32294 3.52698 6.12805 3.85124 5.87695 4.09277C5.62666 4.33346 5.28155 4.53325 4.87695 4.69629L4.87012 4.69922L1.09961 6.1582V7.42285C1.09956 7.72642 0.853322 7.97339 0.549805 7.97363C0.246078 7.97363 4.87328e-05 7.72657 0 7.42285V0.549805C0 0.246048 0.246048 0 0.549805 0ZM1.09961 4.97949L4.46387 3.67578C4.79263 3.5433 5.00074 3.40896 5.11426 3.2998C5.22619 3.19212 5.21028 3.14979 5.21094 3.1748C5.21183 3.20055 5.22549 3.1566 5.10352 3.05371C4.97961 2.94934 4.75808 2.82429 4.40625 2.70801L4.40332 2.70703L1.09961 1.5918V4.97949Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.257fad52f902d8b71aa344074449daf5.svg";
export { ForwardRef as ReactComponent };